// Copyright 2026. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';
import {
    BREAKPOINTS,
    down,
} from 'common/styles/breakpoints';

interface IStorageAlertContainer {
    iconColor?: string;
}

export const StorageAlertContainer = styled.div<IStorageAlertContainer>`
    margin-top: 5px;

    display: flex;
    align-items: center;

    a {
        display: inline-flex;
        align-items: center;
        font-size: 14px;
    }

    svg {
        width: 12px;
        height: 12px;
        margin-right: 10px;
        ${({ iconColor }) => iconColor && `color: ${iconColor};`}

        ${down(BREAKPOINTS.LG)} {
            margin-right: 0;
        }
    }

    ${down(BREAKPOINTS.LG)} {
        span {
            display: none;
        }
    }
`;
